import {
  CHECK_AUTHENTICATION,
  LOGIN,
  LOGOUT,
    CHECK_LOGIN,
    CANCEL_CHECK_LOGIN,
    QR_CODE,
    CHECK_QR_CODE,
    CHECK_LOGIN_START,
    CHECK_LOGIN_END
} from './auth.actionTypes';

const checkAuthentication = data => {
  return dispatch => {
    dispatch({
      type: CHECK_AUTHENTICATION
    });
  }
};

const doLogin = data => {
  return dispatch => {
    dispatch({
      type: LOGIN,
      payload: {
        data
      }
    });
  }
};

const checkLogin = data => {
  return dispatch => {
    dispatch({ type: CHECK_LOGIN_START });
    dispatch({
      type: CHECK_LOGIN,
      payload: { ...data }
    });
    dispatch({ type: CHECK_LOGIN_END });
  }
};

const cancelCheckLogin = data => {
  return dispatch => {
    dispatch({
      type: CANCEL_CHECK_LOGIN,
      payload: {
        data
      }
    });
  }
};

const doLogout = id => {
  return dispatch => {
    dispatch({
      type: LOGOUT
    });
  }
};
const getQRCode = (lat,lng) => {
  console.log("Longitud:", lng, "Latitud:", lat)
  return dispatch => {
    dispatch({
      type: QR_CODE,
      payload:{
        lat,
        lng
      }
    })
  }
}

const chetCheckQRCode = (qrCode) => { 
  return dispatch => {
    dispatch({
      type: CHECK_QR_CODE,
      payload:{
        codigoQR:qrCode
      }
    })
  }
}

export {
  checkAuthentication,
  doLogin,
  doLogout,
  cancelCheckLogin,
  getQRCode,
  chetCheckQRCode,
  checkLogin
};



// WEBPACK FOOTER //
// ./src/state/auth/auth.actions.js